module.exports = __webpack_public_path__ + "static/media/photo-4.71a279d6.jpg";